module.exports = __webpack_public_path__ + "img/gift4-01-c11-k1.64c16136.png";